const VoucherDashboardSkeleton = () => {
  return (
    <div className="bg-slate-50 min-h-screen text-[#3a4d5e] pb-16 font-sans">
      <div className="max-w-[1140px] mx-auto px-4 sm:px-6 py-7 pb-16 space-y-6">
        {/* ================= PAGE HEAD SKELETON ================= */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <div className="h-7 w-52 bg-slate-200 rounded-xl animate-pulse" />
            <div className="h-4 w-72 bg-slate-100 rounded-lg mt-2.5 animate-pulse" />
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <div className="h-9 w-20 bg-white border border-slate-200 rounded-full animate-pulse shadow-2xs" />
            <div className="h-9 w-24 bg-white border border-slate-200 rounded-full animate-pulse shadow-2xs" />
            <div className="h-9 w-24 bg-white border border-slate-200 rounded-full animate-pulse shadow-2xs" />
            <div className="h-9 w-28 bg-[#067978]/15 border border-[#067978]/25 rounded-full animate-pulse shadow-2xs" />
            <div className="h-9 w-24 bg-[#067978]/15 border border-[#067978]/25 rounded-full animate-pulse shadow-2xs" />
          </div>
        </div>

        {/* ================= HERO CARD SKELETON ================= */}
        <div className="rounded-[22px] p-6 sm:p-7 bg-gradient-to-br from-[#045d5c] to-[#067978] text-white shadow-xl shadow-[#067978]/15 flex flex-col md:flex-row justify-between items-start md:items-center gap-6 relative overflow-hidden">
          {/* Background subtle pattern */}
          <div className="absolute inset-0 bg-white/[0.03] pointer-events-none" />

          {/* Left content */}
          <div className="flex-1 min-w-0 space-y-5">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-2xl bg-white/20 animate-pulse shrink-0" />
              <div className="space-y-2">
                <div className="h-6 w-48 sm:w-60 bg-white/30 rounded-lg animate-pulse" />
                <div className="h-3.5 w-32 bg-white/20 rounded-md animate-pulse" />
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-3 sm:gap-4 pt-1">
              <div className="h-8 w-28 bg-white/15 border border-white/10 rounded-xl animate-pulse" />
              <div className="h-8 w-32 bg-white/15 border border-white/10 rounded-xl animate-pulse" />
              <div className="h-8 w-36 bg-white/15 border border-white/10 rounded-xl animate-pulse" />
              <div className="h-8 w-24 bg-white/15 border border-white/10 rounded-xl animate-pulse" />
            </div>
          </div>

          {/* Right countdown box */}
          <div className="w-32 h-28 rounded-[18px] bg-white/10 border border-white/15 p-4 flex flex-col items-center justify-center animate-pulse shrink-0 self-center md:self-auto">
            <div className="h-10 w-14 bg-white/35 rounded-lg mb-2" />
            <div className="h-3 w-20 bg-white/20 rounded" />
            <div className="h-2.5 w-14 bg-white/15 rounded mt-2" />
          </div>
        </div>

        {/* ================= TOUR BOOKINGS ZONE ================= */}
        <div className="pt-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-4 w-28 bg-slate-200 rounded-md animate-pulse" />
            <div className="h-3 w-40 bg-slate-100 rounded-md animate-pulse hidden sm:block" />
            <div className="flex-1 h-px bg-slate-200/80" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Hotel Bookings Card */}
            <div className="bg-white border border-slate-200/80 rounded-[18px] p-5 shadow-xs flex flex-col justify-between space-y-4">
              <div>
                <div className="flex items-center justify-between gap-2 mb-4">
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-xl bg-teal-50 animate-pulse" />
                    <div className="h-3.5 w-28 bg-slate-200 rounded animate-pulse" />
                  </div>
                  <div className="h-5 w-16 bg-teal-50 rounded-full animate-pulse" />
                </div>
                <div className="space-y-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="flex items-center justify-between py-2 border-t border-slate-100 first:border-0">
                      <div className="space-y-1.5">
                        <div className="h-3.5 w-32 bg-slate-200 rounded animate-pulse" />
                        <div className="h-2.5 w-20 bg-slate-100 rounded animate-pulse" />
                      </div>
                      <div className="h-3 w-16 bg-slate-100 rounded animate-pulse" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="h-3 w-24 bg-teal-50 rounded mx-auto animate-pulse pt-1" />
            </div>

            {/* Travel Bookings Card */}
            <div className="bg-white border border-slate-200/80 rounded-[18px] p-5 shadow-xs flex flex-col justify-between space-y-4">
              <div>
                <div className="flex items-center justify-between gap-2 mb-4">
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-xl bg-teal-50 animate-pulse" />
                    <div className="h-3.5 w-28 bg-slate-200 rounded animate-pulse" />
                  </div>
                  <div className="h-5 w-16 bg-teal-50 rounded-full animate-pulse" />
                </div>
                <div className="space-y-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="flex items-center justify-between py-2 border-t border-slate-100 first:border-0">
                      <div className="space-y-1.5">
                        <div className="h-3.5 w-32 bg-slate-200 rounded animate-pulse" />
                        <div className="h-2.5 w-24 bg-slate-100 rounded animate-pulse" />
                      </div>
                      <div className="h-6 w-12 bg-teal-50 rounded-md animate-pulse" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="h-3 w-24 bg-teal-50 rounded mx-auto animate-pulse pt-1" />
            </div>

            {/* Itinerary Card */}
            <div className="bg-white border border-slate-200/80 rounded-[18px] p-5 shadow-xs flex flex-col justify-between space-y-4">
              <div>
                <div className="flex items-center justify-between gap-2 mb-4">
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-xl bg-teal-50 animate-pulse" />
                    <div className="h-3.5 w-24 bg-slate-200 rounded animate-pulse" />
                  </div>
                  <div className="h-5 w-16 bg-blue-50 rounded-full animate-pulse" />
                </div>
                <div className="space-y-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="flex items-start gap-2.5 py-1.5">
                      <div className="h-4 w-12 bg-teal-50 rounded animate-pulse shrink-0 mt-0.5" />
                      <div className="space-y-1 flex-1">
                        <div className="h-3.5 w-full max-w-[140px] bg-slate-200 rounded animate-pulse" />
                        <div className="h-2.5 w-24 bg-slate-100 rounded animate-pulse" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="h-3 w-24 bg-teal-50 rounded mx-auto animate-pulse pt-1" />
            </div>
          </div>

          {/* Important Documents Full-Width Card Skeleton */}
          <div className="bg-white border border-slate-200/80 rounded-[18px] p-5 shadow-xs mt-4 space-y-4">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-xl bg-teal-50 animate-pulse" />
                <div className="h-3.5 w-36 bg-slate-200 rounded animate-pulse" />
              </div>
              <div className="flex items-center gap-2">
                <div className="h-7 w-28 bg-teal-50 rounded-xl animate-pulse" />
                <div className="h-5 w-20 bg-teal-50 rounded-full animate-pulse" />
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="flex items-center justify-between p-3 bg-slate-50 border border-slate-200/70 rounded-xl">
                  <div className="flex items-center gap-2.5 min-w-0">
                    <div className="w-8 h-8 rounded-lg bg-teal-50 animate-pulse shrink-0" />
                    <div className="space-y-1.5">
                      <div className="h-3 w-24 bg-slate-200 rounded animate-pulse" />
                      <div className="h-2 w-16 bg-slate-100 rounded animate-pulse" />
                    </div>
                  </div>
                  <div className="h-6 w-12 bg-white border border-slate-200 rounded-lg animate-pulse shrink-0" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ================= ON-TRIP SERVICES ZONE ================= */}
        <div className="pt-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-4 w-32 bg-slate-200 rounded-md animate-pulse" />
            <div className="h-3 w-48 bg-slate-100 rounded-md animate-pulse hidden sm:block" />
            <div className="flex-1 h-px bg-slate-200/80" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Live Location Card */}
            <div className="bg-white border border-slate-200/80 rounded-[18px] p-5 shadow-xs flex flex-col justify-between space-y-4">
              <div>
                <div className="flex items-center justify-between gap-2 mb-4">
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-xl bg-teal-50 animate-pulse" />
                    <div className="h-3.5 w-28 bg-slate-200 rounded animate-pulse" />
                  </div>
                  <div className="h-5 w-20 bg-teal-50 rounded-full animate-pulse" />
                </div>
                <div className="space-y-3">
                  {[1, 2].map((i) => (
                    <div key={i} className="flex items-center justify-between py-2 border-t border-slate-100 first:border-0">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-teal-500 animate-pulse" />
                        <div className="space-y-1">
                          <div className="h-3.5 w-24 bg-slate-200 rounded animate-pulse" />
                          <div className="h-2.5 w-20 bg-slate-100 rounded animate-pulse" />
                        </div>
                      </div>
                      <div className="flex gap-1.5">
                        <div className="h-6 w-10 bg-teal-50 rounded animate-pulse" />
                        <div className="h-6 w-10 bg-teal-50 rounded animate-pulse" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="h-3 w-24 bg-teal-50 rounded mx-auto animate-pulse pt-1" />
            </div>

            {/* Send Notification Card */}
            <div className="bg-white border border-slate-200/80 rounded-[18px] p-5 shadow-xs space-y-4">
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-xl bg-teal-50 animate-pulse" />
                <div className="h-3.5 w-32 bg-slate-200 rounded animate-pulse" />
              </div>
              <div className="space-y-2">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="h-10 w-full bg-slate-50 border border-slate-100 rounded-xl animate-pulse flex items-center justify-between px-3">
                    <div className="h-3 w-28 bg-slate-200 rounded" />
                    <div className="h-3 w-3 bg-teal-200 rounded" />
                  </div>
                ))}
              </div>
            </div>

            {/* Important Contacts Card */}
            <div className="bg-white border border-slate-200/80 rounded-[18px] p-5 shadow-xs space-y-4">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2.5">
                  <div className="w-8 h-8 rounded-xl bg-teal-50 animate-pulse" />
                  <div className="h-3.5 w-32 bg-slate-200 rounded animate-pulse" />
                </div>
                <div className="h-6 w-20 bg-teal-50 rounded-xl animate-pulse" />
              </div>
              <div className="space-y-2.5">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="flex items-center justify-between py-2 border-t border-slate-100 first:border-0">
                    <div className="flex items-center gap-2.5">
                      <div className="w-8 h-8 rounded-lg bg-teal-50 animate-pulse" />
                      <div className="space-y-1">
                        <div className="h-3.5 w-24 bg-slate-200 rounded animate-pulse" />
                        <div className="h-2.5 w-16 bg-slate-100 rounded animate-pulse" />
                      </div>
                    </div>
                    <div className="h-3 w-12 bg-teal-50 rounded animate-pulse" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoucherDashboardSkeleton;
